// Blog yazıları. Yeni yazı eklemek için diziye yeni bir nesne ekleyin;
// /blog/:slug sayfası ve sitemap otomatik oluşur.
export const posts = [
  {
    slug: "30-yilin-ardindan-kaytazdere",
    title: "30 Yılın Ardından Yeni Adresimiz: Kaytazdere, Altınova",
    excerpt:
      "İstanbul Gaziosmanpaşa'da 30 yıl boyunca başarıyla sürdürdüğümüz LPG ve araç servisi hizmetlerimize Yalova Altınova Kaytazdere'deki yeni iş yerimizde devam ediyoruz.",
    date: "2026-09-05",
    image: "/images/blog/mekanik-lift.jpg",
    tags: ["Duyuru", "Kaytazdere", "Yalova"],
    body: `
<p>İstanbul Gaziosmanpaşa'da 30 yıl boyunca başarıyla sürdürdüğümüz çalışma hayatımıza, Yalova'nın Altınova ilçesine bağlı Kaytazdere'deki yeni iş yerimizde devam ediyoruz. Bu süre boyunca binlerce aracın LPG dönüşümünü, tank değişimini ve bakımını gerçekleştirdik; müşterilerimizin güveniyle büyüdük.</p>
<h2>Neden Kaytazdere?</h2>
<p>Kaytazdere, Yalova–Kocaeli devlet karayolu üzerinde, hem Yalova merkeze hem Altınova ve Karamürsel'e yakın bir noktada. Marmara'nın bu tarafında sıralı sistem LPG konusunda tecrübeli servis ihtiyacı büyük. Yeni yerimizde daha geniş bir atölyede, aynı titizlikle hizmet vereceğiz.</p>
<h2>Neler değişiyor, neler aynı kalıyor?</h2>
<ul>
  <li><strong>Aynı kalan:</strong> Mahir Usta'nın 30 yıllık tecrübesi, 3 aşama 22 nokta kalite kontrolü, Atiker ve Zavoli sıralı sistemler, garantili işçilik.</li>
  <li><strong>Yeni:</strong> Motor yağı değişimi ve çeki demiri montajı hizmetlerimiz yeni yerimizle birlikte başlıyor.</li>
  <li><strong>Yeni:</strong> Web sitemizden randevu ve teklif talebi bırakabilirsiniz; en kısa sürede dönüş yapıyoruz.</li>
</ul>
<h2>Açılış</h2>
<p>Yeni yerimiz <strong>28 Eylül</strong>'de kapılarını açıyor. Adresimiz: Merkez Mah. Devlet Karayolu Cad. No: 148 İç Kapı No: 1, Kaytazdere / Altınova / Yalova. Yol üzerinde olduğumuz için bulmak kolay; yine de yol tarifi için bizi arayabilirsiniz.</p>
<p>Eski müşterilerimize gösterdikleri güven için teşekkür ediyor, Yalova ve çevresindeki yeni komşularımızı atölyemize bekliyoruz.</p>
`,
  },
  {
    slug: "motor-yagi-degisimi-ne-zaman",
    title: "Motor Yağı Ne Zaman Değiştirilmeli? LPG'li Araçlar İçin Özel Notlar",
    excerpt:
      "Motor yağı değişim aralığı, doğru viskozite seçimi ve LPG'li araçlarda yağın neden daha erken değişmesi gerektiği hakkında pratik bilgiler.",
    date: "2026-09-01",
    image: "/images/blog/mekanik-lift.jpg",
    tags: ["Yağ Değişimi", "Bakım"],
    body: `
<p>Motor yağı, motorun içindeki hareketli parçaları yağlar, soğutur ve temizler. Zamanla yağın kimyasal yapısı bozulur, katkıları tükenir ve koruma özelliği azalır. Bu yüzden düzenli değişim, motorun ömrünü doğrudan belirler.</p>
<h2>Değişim aralığı ne olmalı?</h2>
<p>Çoğu üretici 10.000–15.000 km veya yılda bir kez değişim önerir. Ancak bu değerler ideal koşullar içindir. Aşağıdaki durumlarda aralığı kısaltmak gerekir:</p>
<ul>
  <li>Şehir içi, kısa mesafeli ve dur-kalk kullanım</li>
  <li>Sık sık yüksek devirde sürüş veya yük çekme</li>
  <li>Tozlu ortamlarda kullanım</li>
  <li>Aracın uzun süre park halinde beklemesi</li>
</ul>
<h2>LPG'li araçlarda neden farklı?</h2>
<p>LPG, benzine göre daha kuru yanan bir yakıttır ve yanma odası sıcaklığı bir miktar daha yüksektir. Bu, motor yağının termal yükünü artırır. Ayrıca LPG yanması sırasında yağı benzin kadar seyreltmese de, yüksek sıcaklık nedeniyle yağın oksidasyonu hızlanabilir. Bu yüzden LPG'li araçlarda yağ değişim aralığını <strong>%20–30 daha kısa</strong> tutmanızı öneriyoruz. Örneğin üretici 15.000 km diyorsa, 10.000–12.000 km'de değiştirmek motorunuzu korur.</p>
<h2>Doğru yağı nasıl seçersiniz?</h2>
<p>Yağ seçiminde üç şeye bakılır: viskozite (örneğin 5W-30), ACEA/API normu ve varsa üretici onayı (örneğin VW 504.00, MB 229.5). Bunlar aracınızın kullanım kılavuzunda yazar. "Pahalı yağ daha iyidir" doğru değildir; <strong>aracınıza uygun norm</strong> en önemli kriterdir.</p>
<h2>Yağ değişiminde neler yapılır?</h2>
<ol>
  <li>Motor çalışma sıcaklığına getirilir, eski yağ tamamen boşaltılır.</li>
  <li>Yağ filtresi mutlaka değiştirilir. Eski filtreyle yeni yağ kirlenir.</li>
  <li>Yeni yağ doldurulur, seviye kontrol edilir.</li>
  <li>Kaçak kontrolü yapılır, servis göstergesi sıfırlanır.</li>
</ol>
<p>Kaytazdere'deki atölyemizde motor yağı ve filtre değişimini aynı gün, randevusuz yapıyoruz. Aracınıza uygun yağı stoktan sağlıyor, dilerseniz kendi getirdiğiniz yağı da kullanıyoruz.</p>
`,
  },
  {
    slug: "ceki-demiri-taktirmadan-once",
    title: "Çeki Demiri Taktırmadan Önce Bilmeniz Gereken 6 Şey",
    excerpt:
      "Sabit mi sökülebilir mi? 7 pin mi 13 pin mi? Ruhsata işletme zorunlu mu? Çeki demiri montajı hakkında en çok sorulan sorular.",
    date: "2026-08-25",
    image: "/images/blog/arac.jpg",
    tags: ["Çeki Demiri", "Karavan", "Römork"],
    body: `
<p>Karavan, römork, tekne taşıyıcı ya da bisiklet taşıyıcı kullanmak istiyorsanız aracınıza çeki demiri taktırmanız gerekir. Doğru seçim ve doğru montaj hem güvenliğiniz hem de yasal uygunluk için önemlidir.</p>
<h2>1. Aracınızın çekme kapasitesi</h2>
<p>Her aracın frenli ve frensiz römork çekme kapasitesi ruhsatta ve kullanım kılavuzunda yazar. Çeki demiri bu kapasiteyi artırmaz; sadece bağlantı sağlar. Kapasitenin üzerinde yük çekmek hem tehlikeli hem yasa dışıdır.</p>
<h2>2. Sabit mi, sökülebilir mi?</h2>
<ul>
  <li><strong>Sabit çeki demiri:</strong> Daha ekonomiktir, sürekli takılı kalır. Sık römork kullananlar için uygundur.</li>
  <li><strong>Sökülebilir çeki demiri:</strong> Kullanılmadığında top kısmı çıkarılır, tampon görünümü bozulmaz. Park sensörü olan araçlarda tercih edilir.</li>
</ul>
<h2>3. Homologasyon şart</h2>
<p>Takılacak çeki demiri, aracınızın modeline özel üretilmiş ve ECE R55 onaylı olmalıdır. Onaysız veya "uydurma" çeki demirleri hem muayenede sorun çıkarır hem de kaza anında kopabilir.</p>
<h2>4. Elektrik tesisatı: 7 pin mi 13 pin mi?</h2>
<p>7 pin priz, standart römork ve bisiklet taşıyıcı için yeterlidir. Karavanlarda iç aydınlatma, buzdolabı ve akü şarjı için 13 pin gerekir. Modern araçlarda CAN-bus uyumlu modül kullanılmalı; aksi halde arıza lambası yanabilir veya park sensörü sürekli uyarı verir.</p>
<h2>5. Ruhsata işletme</h2>
<p>Türkiye'de çeki demiri montajı ruhsata işletilmek zorundadır. Bunun için montajı yapan servisin fatura ve montaj belgesi, ardından mühendis raporu gerekir. Bu belgeleri montaj sonrası size hazırlıyoruz.</p>
<h2>6. Montaj süresi ve maliyet</h2>
<p>Montaj araca göre 2–4 saat sürer. Maliyet; çeki demirinin tipi (sabit/sökülebilir), elektrik modülü (7/13 pin, CAN-bus) ve araç modeline göre değişir. Net fiyat için araç bilgilerinizle bize ulaşın.</p>
<p>Yalova, Altınova ve Karamürsel çevresinde çeki demiri montajı için Kaytazdere'deki atölyemize bekliyoruz.</p>
`,
  },
  {
    slug: "yalova-altinova-lpg-donusumu-rehberi",
    title: "Yalova ve Altınova'da LPG Dönüşümü: Servis Seçerken Nelere Dikkat Etmeli?",
    excerpt:
      "LPG dönüşümünde servis seçimi sistem markası kadar önemlidir. Yalova çevresinde LPG taktırmadan önce sorulması gereken sorular.",
    date: "2026-08-15",
    image: "/images/services/lpg-montaj.jpg",
    tags: ["LPG Dönüşüm", "Yalova", "Altınova"],
    body: `
<p>LPG dönüşümü, aracınıza yapacağınız en mantıklı yatırımlardan biridir; ancak kötü yapılmış bir montaj tasarrufu bir anda masrafa çevirebilir. Yalova, Altınova, Karamürsel ve çevresinde LPG taktırmayı düşünüyorsanız servis seçerken şu noktalara dikkat edin.</p>
<h2>Ustanın tecrübesi</h2>
<p>LPG montajı standart bir iş değildir. Her motor, her ECU farklı davranır. Sıralı sistemin doğru kalibre edilmesi tamamen ustanın tecrübesine bağlıdır. Servise gittiğinizde kaç yıldır bu işi yaptıklarını ve hangi araçlarda tecrübeleri olduğunu sorun.</p>
<h2>Yetkili servis ve belgeler</h2>
<p>Serviste Hizmet Yeterlilik Belgesi olmalı; montaj sonrası size sızdırmazlık raporu ve montaj belgesi verilmeli. Bu belgeler olmadan aracınızı muayeneden geçiremez, ruhsata LPG işletemezsiniz.</p>
<h2>Sistem markası ve garanti</h2>
<p>Atiker, Zavoli, BRC, Prins, Lovato gibi markalar Türkiye genelinde yaygın servis ağına sahiptir. Sistem garantisinin yanında <strong>işçilik garantisi</strong> de sorun. Biz montajlarımıza 2 yıl garanti veriyoruz.</p>
<h2>Tank seçimi</h2>
<p>Silindir tank daha büyük kapasite sunar ama bagajdan yer alır. Simit tank stepne yuvasına yerleşir, bagajı boş bırakır. Kullanım alışkanlığınıza göre birlikte karar vermek gerekir.</p>
<h2>Montaj sonrası destek</h2>
<p>İlk 1.000 km sonrası ücretsiz kontrol ve ayar yapan bir servis seçin. Sistem yerine oturduktan sonra ince ayar, tüketimi ve performansı ciddi şekilde etkiler.</p>
<h2>Bize sorabilirsiniz</h2>
<p>30 yıllık tecrübemizle Kaytazdere'deki atölyemizde aracınıza uygun sistemi birlikte seçiyor, montajı 22 nokta kalite kontrolü ile teslim ediyoruz. Aracınızın markasını ve modelini yazın, size uygun sistem ve fiyat bilgisini iletelim.</p>
`,
  },
  {
    slug: "lpg-donusumu-nedir-neden-yapilmali",
    title: "LPG Dönüşümü Nedir ve Neden Yapılmalıdır?",
    excerpt:
      "LPG dönüşümü benzinli araçların LPG ile de çalışmasını sağlar. Yakıt tasarrufu, çevre ve motor ömrü açısından avantajları ve montaj süreci.",
    date: "2023-11-05",
    image: "/images/services/lpg-montaj.jpg",
    tags: ["LPG Dönüşüm", "Tasarruf"],
    body: `
<p>LPG dönüşümü, benzinli araçların yakıt sistemine ek bir sistem kurularak sıvılaştırılmış petrol gazı (LPG) ile de çalışmalarını sağlayan bir işlemdir. Dönüşüm yaptıran araç sahipleri hem yakıt tasarrufu hem de daha çevre dostu bir sürüş elde eder. İşin sırrı, montajı ehline bırakmaktır.</p>
<h2>LPG dönüşümünün avantajları</h2>
<ul>
  <li><strong>Yakıt tasarrufu:</strong> LPG litre fiyatı benzinin yaklaşık yarısıdır. Tüketim bir miktar artsa da aylık yakıt masrafı %40'a varan oranda düşer.</li>
  <li><strong>Çevre:</strong> LPG daha temiz yanar; karbon monoksit, hidrokarbon ve azot oksit emisyonları benzine göre belirgin biçimde daha düşüktür.</li>
  <li><strong>Motor ömrü:</strong> LPG yağı seyreltmez, yanma odasında karbon birikimi daha azdır. Doğru bakımla motor ömrü olumsuz etkilenmez.</li>
  <li><strong>Çift yakıt esnekliği:</strong> Araç dilediğiniz an benzine geçebilir; menzil iki katına çıkar.</li>
</ul>
<h2>LPG dönüşümü nasıl yapılır?</h2>
<p>Aracın motoruna LPG enjektörleri, regülatör (buharlaştırıcı), LPG beyni ve anahtar; bagaja ise tank ve multivalf monte edilir. Sistem aracın orijinal benzin sistemine paralel çalışır; motor benzinle çalıştırılır ve ısındığında otomatik olarak gaza geçer. Montaj araca göre ortalama 4-6 saat sürer.</p>
<h2>Kime yaptırmalı?</h2>
<p>LPG dönüşümü mutlaka belgeli, tecrübeli bir servis tarafından yapılmalıdır. Kötü montaj yakıt tüketimini artırır, motor arızalarına ve güvenlik risklerine yol açar. Montaj sonrası sızdırmazlık raporu ve proje belgesi verildiğinden emin olun.</p>
<p>Mahir Usta Otogaz olarak 30 yıldır sıralı sistem LPG montajı yapıyor, her aracı 22 nokta kalite kontrolünden geçirerek teslim ediyoruz.</p>
`,
  },
  {
    slug: "lpg-tank-degisimi-neden-nasil",
    title: "LPG Tank Değişimi: Neden ve Nasıl Yapılır?",
    excerpt:
      "LPG tankları 10 yıl kullanılabilir. Süresi dolan tankın değişimi, adımları, garanti ve dikkat edilmesi gerekenler.",
    date: "2024-07-07",
    image: "/images/services/lpg-tank.jpg",
    tags: ["Tank Değişimi", "Güvenlik"],
    body: `
<p>LPG tankı, üretim tarihinden itibaren 10 yıl kullanım için onaylanır. Bu süre dolduğunda tank yenisiyle değiştirilmelidir. Tank değişimi karmaşık bir işlem değildir; ancak güvenliğiniz için mutlaka LPG sistemleri konusunda uzman bir serviste yaptırılmalıdır.</p>
<h2>Neden kendiniz yapmamalısınız?</h2>
<blockquote>
  <p>"Tank değişimini kendi başınıza yaparken yapılacak küçük bir hata büyük hasara yol açabilir; görünürdeki tasarruf ciddi bir masrafa dönüşür. Başka bir araçtan çıkmış ikinci el tank takmak da yönetmeliğe aykırıdır."</p>
  <footer>Mahir Zirh, Mahir Usta Otogaz</footer>
</blockquote>
<h2>Tank değişim adımları</h2>
<ol>
  <li>Tanktaki gaz güvenli şekilde boşaltılır.</li>
  <li>Multivalf ve bağlantı elemanları sökülür.</li>
  <li>Eski tank çıkarılır, yenisi yerine monte edilir.</li>
  <li>Multivalfin durumu değerlendirilir; gerekiyorsa yenilenir.</li>
  <li>Bağlantılar yapılır, sızdırmazlık testi uygulanır.</li>
  <li>Rapor ve belgeler hazırlanır.</li>
</ol>
<h2>Hangi tankı seçmeli?</h2>
<p>Silindir tank daha fazla kapasite sunar; simit tank stepne yuvasına yerleşerek bagajı boş bırakır. Bagaj kullanımınıza ve menzil beklentinize göre karar verilir. Tüm yeni tanklar ECE R67 homologasyonludur.</p>
<h2>Garanti</h2>
<p>Yeni takılan tanklar üretici garantisi altındadır. Mahir Usta Otogaz olarak değişimi aynı gün yapıyor, sızdırmazlık raporuyla teslim ediyoruz.</p>
<h2>Unutmayın</h2>
<p>Tank kullanım süresi üretim tarihinden itibaren 10 yıldır. Kaza veya mekanik hasar durumunda süreye bakılmaksızın tank değiştirilmelidir. Süresi dolmuş tankla araç muayenesinden geçemezsiniz.</p>
`,
  },
  {
    slug: "lpg-donusumu-hala-karli-mi",
    title: "LPG Dönüşümü Hâlâ Kârlı mı?",
    excerpt:
      "Elektrikli araçların yükselişine rağmen LPG neden hâlâ en ekonomik yakıt seçeneği? Fiyat, BioLPG ve geri ödeme süresi.",
    date: "2024-07-07",
    image: "/images/blog/lastik.jpg",
    tags: ["LPG", "Tasarruf", "BioLPG"],
    body: `
<p>Araçların LPG'ye dönüştürülmesi birçok ülkede uzun yıllardır uygulanan bir yöntem. Otomotiv pazarındaki büyük değişimlere rağmen LPG'nin araç yakıtı olarak kullanımı hâlâ kârlı. Peki neden?</p>
<h2>LPG nedir?</h2>
<p>LPG, propan ve bütanın sıvı karışımıdır. Ham petrolün rafine edilmesi sırasında elde edilir ve doğal gaz yataklarında da bulunur. Son yıllarda biyolojik atıklardan üretilen BioLPG de yaygınlaşmaktadır.</p>
<h2>1. LPG benzinden çok daha ucuz</h2>
<p>Otogaz fiyatı benzin fiyatının yarısından azdır. Bu fiyat ilişkisi Türkiye'de otogaz pazarının geliştiği 30 yılı aşkın süredir devam ediyor. Tüketim %15-20 daha yüksek olsa bile aylık yakıt masrafı belirgin biçimde düşer.</p>
<h2>2. Çevresel değer</h2>
<p>Klasik LPG bile benzine göre daha temiz yanar. BioLPG söz konusu olduğunda karbon ayak izi, elektrik üretiminin fosil kaynaklara dayandığı ülkelerde elektrikli araçlarla yarışır seviyeye iner.</p>
<h2>Dönüşümün maliyeti ve geri dönüşü</h2>
<p>3 ve 4 silindirli yaygın motorlar için sıralı sistem dönüşümü, sistem markasına ve tanka göre değişen bir maliyete sahiptir. Mevcut yakıt fiyatlarıyla bu maliyet, ayda 2.000 km yapan bir sürücü için genellikle 1 yıldan kısa sürede geri döner. Sitemizdeki tasarruf hesaplayıcı ile kendi rakamlarınızı girip görebilirsiniz.</p>
<h2>Kanıtlanmış, güvenli, yaygın</h2>
<p>LPG teknolojisi onlarca yıldır bilinen, olgun bir teknolojidir. Türkiye'de neredeyse her istasyonda otogaz bulunur; ikmal altyapısı sorunu yoktur. Sistem arızaları yaygın servis ağı sayesinde hızla çözülür.</p>
<h2>Sonuç</h2>
<p>Otogazın benzinin yarı fiyatına olması, olgun teknolojisi ve yaygın altyapısı bir araya gelince LPG, özellikle çok kilometre yapan sürücüler için hâlâ en mantıklı seçenek.</p>
`,
  },
  {
    slug: "lpg-mi-elektrikli-arac-mi",
    title: "LPG mi, Elektrikli Araç mı? Ekonomik Karşılaştırma",
    excerpt:
      "Elektrikli araçlar ucuz kullanım vaadiyle geldi; ancak şarj fiyatları ve araç maliyetleri hesabı değiştirdi. LPG'nin 3 ekonomik avantajı.",
    date: "2023-05-18",
    image: "/images/blog/arac.jpg",
    tags: ["LPG", "Elektrikli Araç", "Karşılaştırma"],
    body: `
<p>Bir zamanlar araç LPG sistemlerinin en büyük rakibinin, ekolojik ve çok ucuz olması beklenen elektrikli araçlar olacağı düşünülüyordu. Ancak enerji fiyatlarındaki artış ve elektrikli araçların satın alma maliyeti bu hesabı değiştirdi.</p>
<h2>Elektrikli araçların gerçek maliyeti</h2>
<p>Evde gece tarifesiyle şarj edildiğinde elektrikli araç hâlâ ucuzdur. Ancak apartmanda oturan, şarjı ticari istasyonlardan yapan bir sürücü için 100 km maliyeti, verimli bir benzinli araca yaklaşır. Buna aracın yüksek satın alma fiyatı ve batarya değer kaybı eklendiğinde toplam sahip olma maliyeti beklenenden yüksektir.</p>
<h2>LPG'nin avantajı</h2>
<p>Mevcut aracınızı satmadan, yeni araç kredisi almadan yakıt masrafınızı yarıya indirmenin en hızlı yolu LPG dönüşümüdür.</p>
<h2>LPG'nin 3 ekonomik avantajı</h2>
<ol>
  <li><strong>Hızlı amortisman:</strong> Dönüşüm maliyeti, benzin ve LPG arasındaki fiyat farkıyla çoğu araçta 6-12 ay içinde kendini öder.</li>
  <li><strong>Yarı yarıya yakıt masrafı:</strong> Aynı kilometreyi benzine göre yaklaşık yarı maliyetle yaparsınız.</li>
  <li><strong>Yatırım getirisi:</strong> Dönüşüme harcanan paranın yıllık tasarruf olarak geri dönüşü, aynı paranın mevduat getirisinden çok daha yüksektir.</li>
</ol>
<h2>Sonuç</h2>
<p>Ekonomik olmayan çevrecilik sürdürülebilir değildir. LPG, 30 yıldır araç kullanma maliyetini tutarlı biçimde düşürüyor. Elektrikli araçlar gelecekte daha erişilebilir hale gelene kadar LPG, cebini düşünen sürücü için en gerçekçi seçenek olmaya devam ediyor.</p>
`,
  },
  {
    slug: "otomotiv-sektorunun-gelecegi-lpg-mi-elektrik-mi",
    title: "Otomotiv Sektörünün Geleceği: LPG mi, Elektrik mi?",
    excerpt:
      "Büyük üreticiler farklı yönlere işaret ediyor. Dacia'nın LPG stratejisi ve Euro 7 tartışmaları ışığında otogazın geçiş yakıtı olarak rolü.",
    date: "2024-07-07",
    image: "/images/blog/mekanik-lift.jpg",
    tags: ["Otomotiv", "LPG", "Gelecek"],
    body: `
<p>Belirsiz zamanlardan geçiyoruz ve otomotiv endüstrisi de bu belirsizlikten payını alıyor. En büyük üreticilerden gelen mesajlar tutarsız, hatta çelişkili olduğunda geleceği öngörmek zorlaşıyor.</p>
<h2>Üreticilerin çelişkili açıklamaları</h2>
<p>Bazı büyük otomotiv grupları, elektrifikasyon devam ederken sıkı emisyon standartlarının anlamsız olduğunu savunuyor; aynı grupların bazı markaları ise elektrikli araçların tek yol olmadığını söylüyor.</p>
<h2>Dacia'nın tutarlı LPG stratejisi</h2>
<p>Dacia bu konuda net: 2005'ten beri fabrika çıkışlı LPG'li modeller sunuyor ve yeni motor ailesi de LPG ile çalışacak şekilde tasarlanıyor. Direkt enjeksiyonlu, partikül filtreli bu motorlar çalıştırma anından itibaren otogazla çalışacak. Bu, LPG'nin yeni emisyon standartlarıyla uyumlu olabildiğinin fabrika düzeyinde kanıtı.</p>
<h2>Geçiş yakıtı olarak LPG</h2>
<p>Elektrikli araç altyapısı, batarya maliyetleri ve şebeke kapasitesi konuları çözülene kadar LPG, mevcut içten yanmalı araç parkını daha temiz ve daha ucuz çalıştırmanın en pratik yolu. Türkiye'de milyonlarca LPG'li araç ve yaygın ikmal ağı bunun kanıtı.</p>
<h2>Sonuç</h2>
<p>Önümüzdeki yıllarda araçların güç kaynağı sorusu hâlâ net bir cevap bekliyor. LPG bu geçiş döneminde önemli bir rol oynamaya devam edecek; hangi teknolojinin öne çıkacağını ise zaman gösterecek.</p>
`,
  },
  {
    slug: "turkiyede-lpg-markalari",
    title: "Türkiye'de LPG Sistemi Markaları: Hangisini Seçmeli?",
    excerpt:
      "Atiker, BRC, Prins, Zavoli, Lovato... LPG sistemi seçerken fiyat, servis ağı, garanti ve araç uyumluluğu nasıl değerlendirilir?",
    date: "2023-11-05",
    image: "/images/services/tank-bagaj.jpg",
    tags: ["LPG", "Markalar"],
    body: `
<p>LPG dönüşümü yaptırmak isteyen araç sahipleri Türkiye'de pek çok marka arasından seçim yapabilir. Doğru marka, aracınıza ve bütçenize göre değişir.</p>
<h2>Yaygın markalar</h2>
<p>Türkiye'de en çok tercih edilen sıralı sistem markaları arasında Atiker, BRC, Prins, Lovato, Zavoli, Tartarini, Landirenzo ve OMVL bulunur. Her birinin farklı segmentlere hitap eden kit seçenekleri vardır.</p>
<h2>Seçim kriterleri</h2>
<ul>
  <li><strong>Araç uyumluluğu:</strong> Direkt enjeksiyonlu motorlar özel sistem gerektirir. Her marka her motora uygun değildir.</li>
  <li><strong>Servis ağı:</strong> Şehir dışında arıza yaşadığınızda parçayı ve servisi kolay bulabileceğiniz bir marka seçin.</li>
  <li><strong>Garanti süresi:</strong> Sistem garantisi ve işçilik garantisi ayrı ayrı sorulmalı.</li>
  <li><strong>Yedek parça fiyatı:</strong> Filtre, enjektör ve regülatör fiyatları markadan markaya değişir.</li>
  <li><strong>Ustanın tecrübesi:</strong> Ustanın en iyi bildiği marka, genellikle en iyi sonucu veren markadır.</li>
</ul>
<h2>Bizim tercihimiz</h2>
<p>Mahir Usta Otogaz olarak 30 yıldır ağırlıklı olarak Atiker ve Zavoli sistemleriyle çalışıyoruz. Her iki markanın da yedek parçasını stokta tutuyor, arıza durumunda hızlı çözüm üretiyoruz. Aracınızın modelini bize iletin, uygun sistemi birlikte seçelim.</p>
`,
  },
];

export const sortedPosts = [...posts].sort((a, b) => (a.date < b.date ? 1 : -1));
export const getPost = (slug) => posts.find((p) => p.slug === slug);

// Eski adreslerden yeni adreslere yönlendirme (SEO devamlılığı)
export const legacyRedirects = {
  "/blog-neden-lpg": "/blog/lpg-donusumu-nedir-neden-yapilmali",
  "/blog-hala-karli": "/blog/lpg-donusumu-hala-karli-mi",
  "/blog-faaliyet-firma": "/blog/turkiyede-lpg-markalari",
  "/blog-otomotiv-sektorunun-gelecegi": "/blog/otomotiv-sektorunun-gelecegi-lpg-mi-elektrik-mi",
  "/blog-lpg-tank-degisimi": "/blog/lpg-tank-degisimi-neden-nasil",
  "/blog-lpg-vs-elektrikli-araclar": "/blog/lpg-mi-elektrikli-arac-mi",
  "/montaj": "/hizmetler/lpg-montaj",
  "/tank-degisimi": "/hizmetler/lpg-tank-degisimi",
  "/bakim": "/hizmetler/lpg-bakim",
};

export function formatDate(iso) {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" });
}

export function readingMinutes(html) {
  const words = html.replace(/<[^>]+>/g, " ").trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 130));
}
